<template>
  <div style="width:100%">
    <v-card>
      <!-- Title -->
      <v-card-title style="font-size: 16px; font-weight: bold; color: #506d88; padding: 5px 5px 5px 10px !important">
        <img src="@/assets/PPG_LOGO_PICTO COUL.png" class="exercise-icon" style="width: 30px; vertical-align: -1px; margin-right: 5px" />
        {{ ppgExercise.name }}
      </v-card-title>

      <!-- Videos -->
      <div style="background: #fff" class="p-2">
        <select @change="(e) => changeVideo(e)" class="select mb-5">
          <option :value="ppgExercise.multiCamVideoLink">Multicam</option>
          <option :value="ppgExercise.faceCamVideoLink">Face</option>
          <option :value="ppgExercise.profileCamVideoLink">Profil</option>
          <option :value="ppgExercise.treeQuarterCamVideoLink">Trois quart</option>
        </select>

        <div class="container-video">
          <iframe style="border: none" :src="video || ppgExercise.multiCamVideoLink" class="embed" />
        </div>
      </div>

      <v-card-text class="no-padding-sides">
        <!-- Sets -->
        <exercise-sets :exerciseSet="exerciseSet" v-if="exerciseSet && exerciseSet.set.length > 0" />

        <hr/>

        <!-- Toutes les informations -->
        <v-expansion-panels v-model="open" flat>
          <v-expansion-panel>
            <v-expansion-panel-header style="font-size: 16px; font-weight: bold; color: #506d88">
              <label>{{open == 0 ? "Cacher" : "Voir"}} toutes les Informations</label>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12">
                  <div style="background: #fff" class="p-2">
                    <div class="mt-3" v-if="ppgExercise.critereDeReussite">
                      <label class="font-weight-bold t-blue">Critères de réussite</label>
                      <p style="text-align: justify;">{{ ppgExercise.critereDeReussite }}</p>
                    </div>

                    <div class="mt-3" v-if="ppgExercise.criteresDeRealisation">
                      <label class="font-weight-bold t-blue">Critères de réalisation</label>
                      <p style="text-align: justify;">{{ ppgExercise.criteresDeRealisation }}</p>
                    </div>

                    <div class="mt-3" v-if="ppgExercise.complexification">
                      <label class="font-weight-bold t-blue">Complexification</label>
                      <p style="text-align: justify;">{{ ppgExercise.complexification }}</p>
                    </div>

                    <div class="mt-3" v-if="ppgExercise.simplification">
                      <label class="font-weight-bold t-blue">Simplification</label>
                      <p style="text-align: justify;">{{ ppgExercise.simplification }}</p>
                    </div>

                    <div class="mt-3" v-if="ppgExercise.varianteMateriel">
                      <label class="font-weight-bold t-blue">Variante matériel</label>
                      <p style="text-align: justify;">{{ ppgExercise.varianteMateriel }}</p>
                    </div>

                    <div class="mt-3" v-if="exerciseSet && exerciseSet.critéreRéussite">
                      <label class="font-weight-bold t-blue">Informations complémentaires</label>
                      <p v-html="exerciseSet.critéreRéussite"></p>
                    </div>

                    <div v-if="exerciseSet && exerciseSet.exercisesSetObservables.length > 0">
                      <label class="font-weight-bold t-blue">Observables</label>

                      <p>
                        {{ exerciseSet.exercisesSetObservables | joinObservable }}
                      </p>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ExerciseSets from "@/components/ExerciseSets.mobile";

export default {
  name: "ppg-exercise-view",

  components: {
    ExerciseSets,
  },

  props: {
    exerciseSet: Object,
    ppgExercise: Object,
  },

  data() {
    return {
      video: null,
      open: 1,
    };
  },

  filters: {
    joinObservable: function (observables) {
      return observables.map((item) => item.observable.name).join(", ");
    },
  },

  methods: {
    changeVideo: function (e) {
      this.video = e.target.value;
    },
  },
};
</script>
